import React from 'react'
import { createBrowserRouter } from 'react-router-dom'

import Dashboard from '@SitePages/Dashboard'
import NoMatch from '@SitePages/NoMatch'
import Vocabularies from '@SitePages/Vocabularies'
import Assets from '@SitePages/Assets'
import Labels from '@SitePages/Labels'
import Guidelines from '@SitePages/Guidelines'
import Termbases from '@SitePages/Termbases'
import UsersSignUp from '@SitePages/UsersSignUp'
import UsersSignIn from '@SitePages/UsersSignIn'
import Onboarding from '@SitePages/Onboarding'
import Subscription from '@SitePages/Subscription'
import UsersPasswordNew from '@SitePages/UsersPasswordNew'
import UsersPasswordEdit from '@SitePages/UsersPasswordEdit'
import OTPVerification from '@SitePages/Onboarding/OTPVerification'
import TipsPreview from '@SitePages/Onboarding/TipsPreview'
import ChannelsNew from '@SitePages/ChannelsNew'
import ChannelsManage from '@SitePages/ChannelsManage'
import Processing from '@SitePages/Processing'
import Settings from '@SitePages/Settings'
import VoiceStudio from '@SitePages/VoiceStudio'

import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'

const router = createBrowserRouter(
  [
    {
      element: <PublicRoute />,
      children: [
        {
          path: '/users/sign_up',
          element: <UsersSignUp />
        },
        {
          path: '/users/sign_in',
          element: <UsersSignIn />
        },
        {
          path: '/users/password/new',
          element: <UsersPasswordNew />
        },
        {
          path: '/users/password/edit',
          element: <UsersPasswordEdit />
        }
      ]
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: '/',
          element: <Dashboard />
        },
        {
          path: '/subscriptions',
          element: <Subscription />
        },
        {
          path: '/assets',
          element: <Assets />
        },
        {
          path: '/voice_studio',
          element: <VoiceStudio />
        },
        {
          path: '/labels',
          element: <Labels />
        },
        {
          path: '/settings',
          element: <Settings />
        },
        {
          path: '/channels/new',
          element: <ChannelsNew />
        },
        {
          path: '/channels/manage',
          element: <ChannelsManage />
        },
        {
          path: '/customizations/vocabularies',
          element: <Vocabularies />
        },
        {
          path: '/customizations/guidelines',
          element: <Guidelines />
        },
        {
          path: '/customizations/termbases',
          element: <Termbases />
        },
        {
          path: '/processing',
          element: <Processing />
        },
        {
          path: '/onboarding',
          element: <Onboarding />
        },
        {
          path: '/onboarding/check_email',
          element: <OTPVerification />
        },
        {
          path: '/onboarding/tips_preview',
          element: <TipsPreview />
        }
      ]
    },
    {
      path: '*',
      element: <NoMatch />
    }
  ]
)

export default router
